import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Space, Card, Row } from '@masterteam/mt-design-react';

import KPIUpdateIndicator from '../../../KPIUpdateIndicator';
import UpdateKPIModal from '../../../UpdateKPIModal';
import Gauge from '../../../Gauge';

import {
  formatDate,
  getKPITypeStatusColor,
  reverseStatusesList,
  getKPITypeStatusName
} from '../../../../helpers';
import findArrowIcon from '../../../ArrowIcon';

import { useIsAr } from '../../../../Hooks';

import './style.scss';

function CumulativePerformance({ item, getData }) {
  const [openModal, setOpenModal] = useState(false);

  const [isAr, locale] = useIsAr();

  const {
    Target,
    YearEndTarget,
    Value,
    UnitOfMeasure,
    Direction,
    Status,
    KPIType,
    OutOfTarget,
    Department,
    Division,
    ArabicUnitDetails,
    EnglishUnitDetails,
    HasNoTarget,
    HasNoBaseline,
    MaxTarget,
    CanUpdate,
    UpdateDate,
    IsLocked
  } = item;
  const isNA = Status === 'NA';
  const HasNoTargetBaseline = HasNoTarget || HasNoBaseline;
  // const isAr = locale === 'ar';
  const isPercent = UnitOfMeasure === 'Percentage';
  const unitOfMeasure = isPercent ? '%' : '';

  return (
    <Card
      className="cumulative-performance-container"
      style={{ direction: 'ltr' }}
    >
      <Space direction="vertical" size="large">
        <Row
          justify="between"
          align="start"
          className="cumulative-performance-container_header"
        >
          <Space direction="vertical">
            <div className="cumulative-title">
              <FormattedMessage id="common.cumulative-performance" />
            </div>
            <div className="cumulative-department-division">
              {isAr ? Division?.ArabicName : Division?.EnglishName}
            </div>
            <div className="cumulative-department-division">
              {isAr ? Department?.ArabicName : Department?.EnglishName}
            </div>
          </Space>
          <Space align="center" size="large">
            <Space align="center">
              <FormattedMessage id="common.last-update-date" />:
              <div>{formatDate(UpdateDate)}</div>
            </Space>
            <KPIUpdateIndicator item={item} />
          </Space>
        </Row>
        <div className="cumulative-performance-container_chart">
          <div className="chart-values-section">
            <div className="chart-values-section_item">
              <Space
                className="chart-values-section_value"
                style={{
                  color: getKPITypeStatusColor(KPIType.Status, Status)
                }}
              >
                {isNA ? (
                  <span> {Status}</span>
                ) : (
                  <span>
                    {Value}&nbsp;{unitOfMeasure}
                  </span>
                )}

                {/* {findArrowIcon(
                  Direction,
                  KPIType.Status,
                  Status,
                  HasNoTargetBaseline
                )} */}
              </Space>
              <div>
                <FormattedMessage id="common.actual-value" />
              </div>
            </div>
            <div className="chart-values-section_item">
              <div className="chart-values-section_value">
                {HasNoTargetBaseline ? (
                  <div
                    style={{
                      color: getKPITypeStatusColor(KPIType.Status, Status)
                    }}
                  >
                    NA
                  </div>
                ) : (
                  <>
                    {isNA ? (
                      <span> {Status}</span>
                    ) : (
                      <span>
                        {Target}
                        {unitOfMeasure}
                      </span>
                    )}
                  </>
                )}
              </div>
              <div>
                <FormattedMessage id="kpi-list.target" />
              </div>
            </div>
            <div className="chart-values-section_item">
              {CanUpdate && (
                <Button
                  variant="primary"
                  size="large"
                  onClick={() => setOpenModal(true)}
                  disabled={IsLocked}
                  className="kpi-details__update-button"
                >
                  <FormattedMessage id="kpi-details.update-kpi" />
                </Button>
              )}
            </div>
          </div>
          <Space
            direction="vertical"
            size="large"
            className="cumulative-performance-container_chart_gauge"
            style={{ margin: 8 }}
          >
            <Gauge
              hasNoTargetBaseline={HasNoTargetBaseline}
              progress={HasNoTargetBaseline ? 1000 : OutOfTarget}
              statusColor={getKPITypeStatusColor(KPIType.Status, Status)}
              colors={reverseStatusesList(
                KPIType.Status.filter((e) => e.Min || e.Max)
              )}
            />
            <Space direction="vertical" size="medium">
              <div
                className="cumulative-performance-container_overall"
                style={{
                  color: getKPITypeStatusColor(KPIType.Status, Status)
                }}
              >
                {isNA ? (
                  <span> {Status}</span>
                ) : (
                  <span>
                    {OutOfTarget}&nbsp;
                    {HasNoTargetBaseline ? unitOfMeasure : '%'}
                  </span>
                )}
              </div>
              <div className="cumulative-performance-container_overall-title">
                <FormattedMessage id="common.performance" />
                <div>
                  {getKPITypeStatusName(KPIType.Status, Status, locale)}&nbsp;
                </div>
              </div>

              {IsLocked ? (
                <div className="cumulative-performance-container_overall-title">
                  <FormattedMessage id="common.is-locked-message" />
                </div>
              ) : null}
            </Space>
          </Space>
        </div>
      </Space>
      {openModal ? (
        <UpdateKPIModal
          kpi={item}
          closeModal={() => setOpenModal(false)}
          callback={() => getData()}
        />
      ) : null}
    </Card>
  );
}

export default CumulativePerformance;
